var TabFormsModule = /** @class */ (function () {
    function TabFormsModule() {
    }
    return TabFormsModule;
}());
export { TabFormsModule };
